import { useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";

// Shared scroll-reveal wrapper. Fades + slides content up when it enters view.
export const Reveal = ({ children, delay = 0, y = 30, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

// Staggered container + item for grids.
export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};
export const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

// Hook to reset scroll on route change.
export const useScrollTop = (pathname) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
};
